export const IconTrustedPartnersProvenSafety = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
			<path
				d="M19.5 4.58301V10.083C19.5 15.1705 15.98 19.928 11.25 21.083C6.52004 19.928 3 15.1705 3 10.083V4.58301L11.25 0.916992L19.5 4.58301ZM10.5635 12.1768L7.68457 9.35254L6.25 10.7646L10.5635 15L13.9072 11.7061L17.25 8.41211L15.8154 7L10.5635 12.1768Z"
				fill="#FFB11A"
			/>
		</svg>
	);
};
